import { ApiService } from "../api.service";
import {
  CatalogsReload,
  CatalogsReloadRequest,
  CatalogsUpdateDates,
} from "@/models/entities/catalogsReload/catalogsReload.interface";
import { SaveCatalogsResponse } from "@/models/entities/catalogsReload/catalogsReloadInput/catalogsReloadInput.interface";

const CONTROLLER = "catalogsreload";
const CONTROLLER_DATES = "cataloguesupdate";

class CatalogService extends ApiService {
  getCatalogs(id: number) {
    const parameters = "?catalogueSourceID=" + id;

    return this.getAll<CatalogsReload[]>(
      `${CONTROLLER}/getpricebycatalogue${parameters}`
    );
  }

  saveCatalogs(values: CatalogsReloadRequest) {
    return this.post<CatalogsReloadRequest, SaveCatalogsResponse>(
      `${CONTROLLER}/savecatalogueprice`,
      values
    );
  }

  getCatalogsUpdateDates() {
    return this.getAll<CatalogsUpdateDates[]>(
      `${CONTROLLER_DATES}/getlastmodifiedlist`
    );
  }
}

export const catalogService = new CatalogService();
